<template>
  <iframe 
    src="/referral.html" 
    class="referral-iframe"
    frameborder="0"
    title="Referral Program">
  </iframe>
</template>

<script>
export default {
  name: 'ReferralProgramPage'
}
</script>

<style scoped>
.referral-iframe {
  width: 100%;
  height: 100vh;
  border: none;
  display: block;
}
</style>

